import styled from "styled-components";
import { Button } from "@npm-telluria-tecnologia/telluria-ui";

const ShowMoreButton = styled(Button)`
  margin-top: 20px !important;
  background-color: ${(props) => props.theme.colors.primary} !important;

  :hover {
    background-color: ${(props) => props.theme.colors.secondary} !important;
  }
`;

export { ShowMoreButton };
